import { getTranslatedSubmissionStatusName } from '@module/assignment';
import { Button, Progress, Space, Tooltip } from 'antd';
import { styleVariables } from '@lib/common';
import { getDateTime } from '../../../../assignment-components';
import { EyeOutlined, LoadingOutlined } from '@ant-design/icons';
import { SubmissionStatusComponent } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var renderProgressBar = function renderProgressBar(percent) {
  if (percent <= 0) {
    return /*#__PURE__*/_jsx(Progress, {
      percent: 0,
      status: "active",
      strokeColor: styleVariables.colors.gold1
    });
  }

  if (percent <= 50) {
    return /*#__PURE__*/_jsx(Progress, {
      percent: percent,
      status: "active",
      strokeColor: styleVariables.colors.gold1,
      trailColor: '#FDE6B6'
    });
  }

  return /*#__PURE__*/_jsx(Progress, {
    percent: percent,
    status: "active",
    trailColor: styleVariables.colors.blue1
  });
};

export var renderColumns = function renderColumns(_ref) {
  var label = _ref.label,
      assignment = _ref.assignment,
      onOpenAttendeeSubmission = _ref.onOpenAttendeeSubmission;
  return [{
    title: label.submitTime,
    dataIndex: 'submitTime',
    key: 'submitTime',
    render: function render(_, record) {
      if (!record.report.submitTime) {
        if (assignment.isEnded()) {
          return /*#__PURE__*/_jsx(_Fragment, {
            children: getDateTime(+assignment.endTime)
          });
        }

        return /*#__PURE__*/_jsx("span", {
          children: "#N/A"
        });
      }

      return /*#__PURE__*/_jsx(_Fragment, {
        children: getDateTime(parseInt(record.report.submitTime))
      });
    }
  }, {
    title: label.fullName,
    key: 'fullName',
    render: function render(_, record) {
      return /*#__PURE__*/_jsxs("span", {
        children: [record.firstName, " ", record.lastName]
      });
    }
  }, {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: record.email
      });
    }
  }, {
    title: label.submissionStatus,
    key: 'submissionStatus',
    render: function render(_, record) {
      if (!record.report.status) {
        return /*#__PURE__*/_jsx("span", {
          children: "#N/A"
        });
      }

      return /*#__PURE__*/_jsx(SubmissionStatusComponent, {
        statusType: record.report.status.id,
        text: getTranslatedSubmissionStatusName(record.report.status.id, record.report.status.name, label)
      });
    }
  }, {
    title: label.gradingStatus,
    key: 'gradingStatus',
    render: function render(_, record) {
      if (!assignment.isEnded()) {
        return /*#__PURE__*/_jsx("span", {
          children: "#N/A"
        });
      }

      if (record.report.isOnGradingProcess()) {
        return /*#__PURE__*/_jsxs(Space, {
          children: [/*#__PURE__*/_jsx(LoadingOutlined, {}), /*#__PURE__*/_jsx("span", {
            children: label.onGradingProcess
          })]
        });
      }

      return renderProgressBar(record.report.gradedPercentage);
    }
  }, {
    title: label.score,
    key: 'score',
    render: function render(_, record) {
      if (!record.report.gradedPercentage || record.report.gradedPercentage < 100) {
        return /*#__PURE__*/_jsx("span", {
          children: "#N/A"
        });
      }

      return /*#__PURE__*/_jsx(_Fragment, {
        children: record.report.score
      });
    }
  }, {
    render: function render(_, record) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: label.clickToViewDetail,
        children: /*#__PURE__*/_jsx(Button, {
          type: "text",
          onClick: function onClick() {
            return onOpenAttendeeSubmission(record);
          },
          children: /*#__PURE__*/_jsx(EyeOutlined, {})
        })
      });
    }
  }];
};